import {ApolloClient, ApolloLink, createHttpLink, InMemoryCache} from '@apollo/client/core';
import {BatchHttpLink} from "@apollo/client/link/batch-http";
import {withScalars} from "apollo-link-scalars";
import {getCsrfToken} from "@/csrf";
import {schema, hpoSchema, typesMap} from "@/graphql/schema";
import {getAbsoluteUrl, reverseUrl} from "@/url";

export const DEFAULT_POLL_INTERVAL = 1000 * 1000;

let _requestHeaders = null;

export function setGraphQLHeaders(headers) {
    _requestHeaders = headers;
}

export function clearGraphQLHeaders() {
    _requestHeaders = null;
}

function fetchWithDynamicHeaders(resource, options = {}) {
    const newOptions = {...options};
    if (_requestHeaders !== null) {
        if (newOptions.headers) {
            Object.assign(newOptions.headers, _requestHeaders);
        } else {
            newOptions.headers = _requestHeaders;
        }
    }

    return window.fetch(resource, newOptions);
}

let createLink = function (batch, urlName, headers) {
    if (batch) {
        return new BatchHttpLink({
            fetch: fetchWithDynamicHeaders,
            uri: getAbsoluteUrl(reverseUrl(urlName)),
            headers: headers,
            batchMax: 4,
            batchInterval: 10,
        });
    } else {
        return createHttpLink({
            fetch: fetchWithDynamicHeaders,
            uri: getAbsoluteUrl(reverseUrl(urlName)),
            headers: headers,
        });
    }
};

export function createApolloClient(schemaData, urlName, batch = false) {
    const headers = {
        'X-CSRFToken': getCsrfToken(),
    };

    const httpLink = createLink(batch, urlName, headers);

    const link = ApolloLink.from([
        withScalars({schema: schemaData, typesMap}),
        httpLink,
    ]);

    // Caching.
    const cache = new InMemoryCache();

    return new ApolloClient({
        link,
        cache,
    });
}

export const apolloClient = createApolloClient(schema, 'web:api_v1:graphql_batch', true);

